// extracted by mini-css-extract-plugin
module.exports = {"content":"ScreenCalculate_content__w8YMl","horizontal":"ScreenCalculate_horizontal__1A8Wk","placeholder":"ScreenCalculate_placeholder__28yqO","link":"ScreenCalculate_link__2xtw7"};